<!--
 * @Description: 新加坡CAC-breadCrumb
 * @Version: 2.0
 * @Author: Viborder
 * @Date: 2023-07-17 10:41:00
 * @LastEditors: Viborder
 * @LastEditTime: 2023-08-02 10:36:18
 * @company: NUCTECH
 * @Mailbox: nuctech@nuctech.com
 * @FilePath: /src/components/common/breadCrumb.vue
-->
<template>
  <el-breadcrumb :separator="breadcrumb.font" :separator-class="breadcrumb.class" class="margins">
    <el-breadcrumb-item
      v-for="(item, index) in breadcrumb.data"
      :to="{ path: item.path }"
      :replace="item.replace"
      :key="index"
    >{{ item.label }}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'SgpBreadcrumb',
  props: ['breadcrumb']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
::v-deep.margins {
  margin-bottom: 20px;
  .el-breadcrumb__item {
    .el-breadcrumb__inner.is-link {
      color: #1782d4;
      font-size: 14px;
      font-weight: normal;
    }
  }

  span:last-child {
    .el-breadcrumb__inner.is-link {
      color: #000;
    }
  }
}
</style>
